const firebaseConfig = {
    apiKey: "AIzaSyDD38VKoLkCGPjJ9qBT4RmV6YtzIoPPX20",
    authDomain: "healthy-food-754a3.firebaseapp.com",
    projectId: "healthy-food-754a3",
    storageBucket: "healthy-food-754a3.appspot.com",
    messagingSenderId: "477791134263",
    appId: "1:477791134263:web:91b39e024e6151b0a2d5b2"
  };
export default firebaseConfig;